import React, { useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Barbara Saunders',
  rating: 5,
  text: 'I had a faulty washing machine and Maplewood Care sorted it out quickly and professionally. The engineer was friendly, punctual, and explained everything clearly. Pricing was transparent with no surprises. Highly recommend!'
}, {
  name: 'Emma Rosenberg',
  rating: 5,
  text: 'Brilliant service from start to finish. Booking was easy, the repair team arrived on time, and my boiler was fixed on the same day. I felt well cared for throughout. Definitely using Maplewood Care again!'
}, {
  name: 'Dave Wilson',
  rating: 5,
  text: "Great experience with Maplewood Care. From booking the repair to the engineer's visit, everything was smooth and hassle-free. The technician was professional and fixed my cooker quickly. Will recommend to friends and family."
}, {
  name: 'Amy Jones',
  rating: 5,
  text: 'Maplewood Care gave me peace of mind with their prepaid maintenance package. The team is reliable and very knowledgeable. When my dishwasher broke down, they had it repaired within 48 hours. Excellent customer care!'
}, {
  name: 'Thomas Hargreaves',
  rating: 5,
  text: "Outstanding service! My fridge was repaired the same day I called. The engineer was courteous and efficient. Maplewood Care's customer service is top-notch."
}, {
  name: 'Sarah Mitchell',
  rating: 5,
  text: "I've been with Maplewood Care for two years now, with prepaid maintenance for multiple appliances. Their response time is excellent and the engineers are always professional. Great value for money!"
}, {
  name: 'James Cooper',
  rating: 5,
  text: 'After struggling with my dishwasher for weeks, Maplewood Care fixed it in just one visit. The engineer explained what was wrong and how to prevent future issues. Very impressed!'
}, {
  name: 'Rebecca Taylor',
  rating: 5,
  text: 'The customer service team is so helpful and friendly. They arranged a repair for my washing machine promptly, and the engineer did a fantastic job. Would definitely recommend Maplewood Care.'
}];
const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (autoplay) {
      interval = setInterval(() => {
        setActiveIndex(current => current === testimonials.length - 3 ? 0 : current + 1);
      }, 5000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autoplay]);
  const handlePrev = () => {
    setAutoplay(false);
    setActiveIndex(current => current === 0 ? testimonials.length - 3 : current - 1);
  };
  const handleNext = () => {
    setAutoplay(false);
    setActiveIndex(current => current === testimonials.length - 3 ? 0 : current + 1);
  };
  return <section className="py-16 bg-white" data-id="element-80">
      <div className="container mx-auto px-4" data-id="element-81">
        <div className="text-center mb-12" data-id="element-82">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-83">
            Why Thousands Choose Us
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-84">
            Hear from our satisfied customers who trust Maplewood Care for their
            appliance repair needs.
          </p>
        </div>
        <div className="relative" data-id="element-85">
          <div className="overflow-hidden" data-id="element-86">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${activeIndex * 33.33}%)`
          }} data-id="element-87">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full md:w-1/3 flex-shrink-0 px-4" data-id="element-88">
                  <div className="bg-gray-50 p-6 rounded-lg shadow-sm h-full" data-id="element-89">
                    <div className="flex text-yellow-400 mb-3" data-id="element-90">
                      {[...Array(testimonial.rating)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-91" />)}
                    </div>
                    <p className="text-gray-600 mb-4" data-id="element-92">"{testimonial.text}"</p>
                    <p className="font-semibold text-gray-800" data-id="element-93">
                      {testimonial.name}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
          <button className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md text-gray-800 hover:text-blue-700 focus:outline-none" onClick={handlePrev} data-id="element-94">
            <ChevronLeft size={24} data-id="element-95" />
          </button>
          <button className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md text-gray-800 hover:text-blue-700 focus:outline-none" onClick={handleNext} data-id="element-96">
            <ChevronRight size={24} data-id="element-97" />
          </button>
        </div>
      </div>
    </section>;
};
export default Testimonials;